@for (item of column.links; track $index) {
<href [link]="item.link"
      [hrefClass]="'flex flex-middle'">
      <span class="p1"
            *iCms="'text' of item"></span>
</href>
}